import axios from 'axios'
import Ship from '../types/Ship'

export async function fetchShips() {
  if (process.env.REACT_APP_SHIP_URL) {
    const { data } = await axios.get(process.env.REACT_APP_SHIP_URL, {
      headers: { 'Access-Control-Allow-Origin': '*', 'Cache-Control': 'no-cache' },
    })
    return data as Array<Ship>
  }
  return []
}
